import { gql } from "lib/apolloClient";
import { staffFragment } from "modules/CommonFragments";

const standardFragment = {
  plannerElementNode: gql`
    fragment rubricPlannerElementNodeItem on PlannerElementNode {
      id
      label
      code
      type
      standardsWrapper {
        standardSet {
          id
          type
          title
          subject {
            id
          }
        }
      }
    }
  `,
  benchmark: gql`
    fragment rubricBenchmarkItem on PlannerBenchmark {
      id
      label
      code
      type
      standardsWrapper {
        standardSet {
          id
          type
          title
          subject {
            id
          }
        }
      }
    }
  `,
};

export const standardRubricElementsFragment = {
  descriptor: gql`
    fragment standardRubricDescriptorItem on StandardRubricDescriptor {
      id
      label
      score
      description
      displaySequence
      gradeScaleValue {
        id
        label
        abbreviation
      }
      standardGradeScaleValueDescriptor {
        id
        description
        gradeScaleValue {
          id
        }
      }
    }
  `,
  criteria: gql`
    fragment standardRubricCriteriaItem on StandardRubricCriteria {
      id
      label
      description
      displaySequence
      maxScore
      standard {
        ...rubricPlannerElementNodeItem
      }
      benchmark {
        ...rubricBenchmarkItem
      }
      descriptors: standardRubricDescriptors {
        id
        label
        score
        description
        displaySequence
        gradeScaleValue {
          id
          label
          abbreviation
        }
        standardGradeScaleValueDescriptor {
          id
          description
          gradeScaleValue {
            id
          }
        }
      }
    }
    ${standardFragment.plannerElementNode}
    ${standardFragment.benchmark}
  `,
};

export const standardRubricFragment = {
  standardRubric: gql`
    fragment standardRubricItem on StandardRubric {
      id
      title: label
      standardRubricCriterias {
        ...standardRubricCriteriaItem
      }
      associateScoreTool {
        id
        scoreToolData {
          id
          maxScore
          isCustomMaxScore
        }
      }
      createdBy {
        ...staffItem
      }
      gradeScale {
        id
        gradingType
      }
      lastEdited: updatedAt
      updatedBy {
        ...staffItem
      }
      metadata
    }
    ${standardRubricElementsFragment.criteria}
    ${staffFragment.basicStaffDetails}
  `,
};
